"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphConnectorProjectTypeNode = void 0;
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const create_1 = require("../../create");
function graphConnectorProjectTypeNode() {
    return {
        condition: { equals: ProjectTypeOptions_1.ProjectTypeOptions.graphConnectorOptionId },
        data: {
            type: "group",
        },
        children: [
            {
                data: (0, create_1.GCNameQuestion)(),
            },
            {
                data: (0, create_1.GCConnectionIdQuestion)(),
            },
        ],
    };
}
exports.graphConnectorProjectTypeNode = graphConnectorProjectTypeNode;
//# sourceMappingURL=graphConnectorProjectTypeNode.js.map